<template>
  <v-dialog v-model="open" max-width="760" persistent scrollable class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <template v-if="isEdit">
            <span style="color: #2655F1;">编辑</span><span>充电桩</span>
          </template>
          <template v-else>
            <span style="color: #2655F1;">新增</span><span>充电桩</span>
          </template>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>
      <v-card-text class="pa-8 pt-0">
        <div class="form-grid-2">
          <div class="form-group">
            <label>产品型号 <span class="required-star">*</span></label>
            <v-select v-model="draft.productModel" :items="pileModelOptions" item-title="title" item-value="value"
              :loading="pileModelLoading" placeholder="请选择产品型号" variant="flat" density="compact" class="gm-input"
              hide-details @update:model-value="(v) => emit('model-change', v)" />
          </div>
          <div class="form-group">
            <label>充电桩名称 <span class="required-star">*</span></label>
            <v-text-field v-model="draft.chargePileName" placeholder="请输入充电桩名称" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>厂家名称</label>
            <v-text-field v-model="draft.factoryName" placeholder="请选择产品型号后自动带出" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>UUID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.uuid" placeholder="选择产品型号后自动生成UUID" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>设备devID</label>
            <v-text-field v-model="draft.devId" placeholder="请输入设备devID" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>关联设备devID <span class="required-star">*</span></label>
            <v-select v-model="draft.parentEquipmentId" :items="pileParentEquipmentOptions" item-title="title"
              item-value="value" placeholder="请选择关联设备devID" variant="flat" density="compact" class="gm-input"
              hide-details />
          </div>
          <div class="form-group">
            <label>输入电压(V)</label>
            <v-text-field v-model="draft.inputVoltage" placeholder="请选择产品型号后自动带出" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>输出电压(V)</label>
            <v-text-field v-model="draft.outputVoltage" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>额定输出功率(kW)</label>
            <v-text-field v-model="draft.ratedOutputPower" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>满载功率因数</label>
            <v-text-field v-model="draft.fullLoadPower" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>充电接口类型</label>
            <v-text-field v-model="draft.chargeInterface" placeholder="请选择产品型号后自动带出" variant="flat"
              density="compact" class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>充电模式</label>
            <v-select v-model="draft.chargeMode" :items="pileChargeModeOptions" item-title="title"
              item-value="value" placeholder="请选择产品型号后自动带出" variant="flat" density="compact" class="gm-input"
              hide-details readonly :menu-props="{ disabled: true }" :model-value="draft.chargeMode || null" />
          </div>
          <div class="form-group">
            <label>排序号</label>
            <v-text-field v-model.number="draft.sort" type="number" min="0" placeholder="请输入排序号" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4" @click="emit('close')">取消</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="submitting"
          @click="emit('submit')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { pileChargeModeOptions } from '../utils/constants'

const open = defineModel({ type: Boolean, default: false })
defineProps({
  draft: { type: Object, required: true },
  isEdit: { type: Boolean, default: false },
  submitting: { type: Boolean, default: false },
  pileModelOptions: { type: Array, default: () => [] },
  pileModelLoading: { type: Boolean, default: false },
  pileParentEquipmentOptions: { type: Array, default: () => [] },
})
const emit = defineEmits(['close', 'submit', 'model-change'])
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
